import { shortUUID } from '../base/utils/id-generator'
import { IHistoryItem } from '../interfaces/history'
import { ITodo } from '../interfaces/todo'

export function create(prompt: string, urls: string[], mode: string): IHistoryItem {
    const at = new Date().toISOString()
    const last_changed = at
    return {
        id: shortUUID(), 
        prompt, 
        urls, 
        mode, 
        at, 
        last_changed, 
        synced: 0, 
        isFavorite: 0
    }
}

export default {
    create
}